<template>
  <div>
    <Head title="Persyaratan Pertanggung Jawaban" />
    <h1 class="mb-8 text-2xl font-bold">Persyaratan Pertanggung Jawaban</h1>
    <div class="flex items-center justify-end mb-6">
      <Link v-if="can('write persyaratan')" class="btn-indigo" href="/persyaratan-pertanggungjawabans/create">
        <span><font-awesome-icon icon="fas fa-plus" class="mr-2" />Tambah</span>
      </Link>
    </div>
    <div class="bg-white rounded-md shadow overflow-x-auto">
      <table class="w-full whitespace-nowrap">
        <thead>
          <tr class="text-left font-bold">
            <th class="pb-4 pt-6 px-6">Nama</th>
            <th class="pb-4 pt-6 px-6 text-center">Wajib</th>
            <th v-if="can('write persyaratan')" class="pb-4 pt-6 px-6 border-b">Aksi</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="persyaratan in persyaratans.data" :key="persyaratan.id" class="hover:bg-gray-100 focus-within:bg-gray-100">
            <td class="border-t p-4">
              {{ persyaratan.nama }}
            </td>
            <td class="border-t p-4 text-center">
              <font-awesome-icon v-if="persyaratan.is_required" icon="fas fa-circle-check" class="text-green-500" />
              <font-awesome-icon v-if="!persyaratan.is_required" icon="fas fa-circle-xmark" class="text-red-500" />
            </td>
            <td v-if="can('write persyaratan')" class="p-4 w-px border-t">
              <Link class="btn-indigo-sm rounded-l" :href="`/persyaratan-pertanggungjawabans/${persyaratan.id}/edit`">
                <font-awesome-icon icon="fas fa-pencil" />
              </Link>
              <Link class="btn-red-sm rounded-r" @click.prevent="destroy(persyaratan.id)">
                <font-awesome-icon icon="fas fa-trash" />
              </Link>
            </td>
          </tr>
          <tr v-if="persyaratans.data.length === 0">
            <td class="px-6 py-4 border-t" :colspan="can('write persyaratan')? 5 : 4">Tidak ada data persyaratan.</td>
          </tr>
        </tbody>
      </table>
    </div>
    <pagination class="mt-6" :links="persyaratans.links" />
  </div>
</template>

<script>
import { Head, Link } from '@inertiajs/inertia-vue3'
import Layout from '@/Shared/Layout'
import Pagination from '@/Shared/Pagination'

export default {
  components: {
    Head,
    Link,
    Pagination,
  },
  layout: Layout,
  props: {
    persyaratans: Object,
  },
  methods: {
    destroy(id) {
      this.$swal.fire({
        title: 'Anda yakin hapus data ini?',
        text: 'Anda tidak akan dapat mengembalikan data yang sudah dihapus!',
        icon: 'question',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Ya',
        cancelButtonText: 'Tidak',
      }).then((result) => {
        if (result.isConfirmed) {
          this.$inertia.delete(`/persyaratan-pertanggungjawabans/${id}`)
        }
      })
    },
  },
}
</script>
